export const formatNumber = (value: string | number): string => {
  if (value === null || undefined) return "";
  const num =
    typeof value === "string" ? parseFloat(value.replace(/,/g, "")) : value;
  if (isNaN(num)) return value.toString();

  return num.toLocaleString("en-GB", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 4,
  });
};
